import { render, staticRenderFns } from "./ProcessesList.vue?vue&type=template&id=561f4e9e&"
import script from "./ProcessesList.vue?vue&type=script&lang=js&"
export * from "./ProcessesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports